import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'
import { hasOwnPublishedModule } from '@/utils/contentModuleTables'

/**
 * Whether the channel has published a content module of its own; undefined until the list loads. The list
 * is never stale for this observer, so the nav doesn't refetch it on mount or focus, but it stays active, so
 * an invalidation after a publish or unpublish still refetches it.
 */
export function useHasPublishedModule(enabled = true): boolean | undefined {
  const { api } = useGlobalState()
  const { data } = useQuery({
    queryKey: ['cm', 'list'],
    queryFn: () => api.getContentModules(),
    enabled,
    staleTime: Infinity,
    select: hasOwnPublishedModule,
  })
  return data
}
